import type { TSummarySection } from 'types/summary';
import type { TPreviewMessageAsset } from 'utils/messagePreview';
import { convertDraftSectionsToMessageSections } from '../SendMessageForAll/utils';

export function buildSummaryPreviewData(sections: TSummarySection[]) {
  const assetsById = new Map<number, TPreviewMessageAsset>();

  for (const section of sections) {
    if (!('assetId' in section) || !section.asset) continue;

    assetsById.set(section.assetId, {
      id: section.assetId,
      type: section.asset.type,
      name: section.asset.name,
      payload: section.asset.payload,
      previewImageUrl: section.asset.previewImageUrl,
    });
  }

  return {
    sections: convertDraftSectionsToMessageSections(sections),
    assets: [...assetsById.values()],
  };
}
